import { useTranslation } from '@crehana/i18n';
import SearchIcon from '@crehana/icons/Search';
import { grayLight } from '@crehana/ui/dist/styles/colors';

const EmptyCase = () => {
  const { t } = useTranslation();

  return (
    <div className="py-24 px-12 flex flex-col items-center justify-center">
      <SearchIcon color={grayLight} size={48} className="mb-16" />
      <p className="font-subtitle3 text-center mb-4">
        {t('SEARCH_EMPTY_TITLE')}
      </p>
      <p className="font-body4 text-center">{t('SEARCH_EMPTY_SUBTITLE')}</p>
    </div>
  );
};

export default EmptyCase;
